import { GoogleMapsModule } from '@angular/google-maps';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { OverlayModule } from '@angular/cdk/overlay';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { AutoSizeInputModule } from 'ngx-autosize-input';
import { ActionsMenuComponent } from '@macs-frontend/features/shared/components/actions-menu/actions-menu.component';
import { ActivityLogComponent } from '@macs-frontend/features/shared/components/activity-log/activity-log.component';
import { ContactKindBadgeComponent } from '@macs-frontend/features/shared/components/contact-kind-badge/contact-kind-badge.component';
import { DropdownUserOptionComponent } from '@macs-frontend/features/shared/components/dropdown-user-option/dropdown-user-option.component';
import { DropdownUserSelectedComponent } from '@macs-frontend/features/shared/components/dropdown-user-selected/dropdown-user-selected.component';
import { ExactSyncSpinnerComponent } from '@macs-frontend/features/shared/components/exact-sync-spinner/exact-sync-spinner.component';
import { ModalRightComponent } from '@macs-frontend/features/shared/components/modal-right/modal-right.component';
import { PromptPopupComponent } from '@macs-frontend/features/shared/components/prompt-popup/prompt-popup.component';
import { SaveButtonComponent } from '@macs-frontend/features/shared/components/save-button/save-button.component';
import { SpoStatusTooltipComponent } from '@macs-frontend/features/shared/components/spo-status-tooltip/spo-status-tooltip.component';
import { FormErrorDirective } from '@macs-frontend/features/shared/directives/form-error.directive';
import { RangeInputDirective } from '@macs-frontend/features/shared/directives/range-input.directive';
import { InvoiceItemQuantityPipe } from '@macs-frontend/features/shared/pipes/invoice-item-quantity.pipe';
import { ProjectEstimatedAbsoluteMarginPipe } from '@macs-frontend/features/shared/pipes/project-estimated-absolute-margin.pipe';
import { ToStringPipe } from '@macs-frontend/features/shared/pipes/to-string.pipe';
// xplat
import { UIKitModule, UIModule } from '@macs-frontend/web';
import { AttachedComponent } from '@macs-frontend/web-macs/shared/components/attached/attached.component';
import { FilterBarComponent } from '@macs-frontend/web-macs/shared/components/filter-bar/filter-bar.component';
import { FilterDropdownComponent } from '@macs-frontend/web-macs/shared/components/filter-dropdown/filter-dropdown.component';
import { ScheduleTimelineComponent } from '@macs-frontend/web-macs/shared/components/schedule-timeline/schedule-timeline.component';
import { ScheduleTimelineGraphComponent } from './components/schedule-timeline/schedule-timeline-graph/schedule-timeline-graph.component';
import { TeamCostComponent } from '@macs-frontend/features/shared/components/teamcost/team-cost.component';
import { TaskComponent } from './components/teamcost/task/task.component';
import { ServiceComponent } from './components/teamcost/service/service.component';
import { TableHeaderComponent } from '@macs-frontend/web-macs/shared/components/table-header/table-header.component';
import { TableComponent } from '@macs-frontend/web-macs/shared/components/table/table.component';
import { TagsComponent } from '@macs-frontend/web-macs/shared/components/tags/tags.component';
import { NumberInputDirective } from '@macs-frontend/web-macs/shared/directives/number-input.directive';
import { OutsideClickDirective } from '@macs-frontend/web-macs/shared/directives/outside-click.directive';
import { ActionConfirmationStatusPipe } from '@macs-frontend/web-macs/shared/pipes/action-confirmation-status.pipe';
import { ActionTeamNamePipe } from '@macs-frontend/web-macs/shared/pipes/action-team-name.pipe';
import { ProvinceLabelPipe } from '@macs-frontend/web-macs/shared/pipes/province-label.pipe';
import { CalculateAgePipe } from '@macs-frontend/web-macs/shared/pipes/calculate-age.pipe';
import { EnumValuesToArrayPipe } from '@macs-frontend/web-macs/shared/pipes/enum-values-to-array.pipe';
import { FromNowPipe } from '@macs-frontend/web-macs/shared/pipes/from-now.pipe';
import { HumanizeTextCodePipe } from '@macs-frontend/web-macs/shared/pipes/humanize-text-code.pipe';
import { SecondsToHoursPipe } from '@macs-frontend/web-macs/shared/pipes/seconds-to-hours.pipe';
import { SnakeCaseToDashCase } from '@macs-frontend/web-macs/shared/pipes/snake-case-to-dash-case';
import { TitleCasePipe } from '@macs-frontend/web-macs/shared/pipes/title-case.pipe';
import { ContenteditableValueAccessorModule } from '@tinkoff/angular-contenteditable-accessor';
import { CommonModule } from '@angular/common';
import { IMaskModule } from 'angular-imask';
import { MobxAngularModule } from 'mobx-angular';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgrxFormsModule } from 'ngrx-forms';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NgxTippyModule } from 'ngx-tippy-wrapper';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { ActionsPopupComponent } from './components/actions-popup/actions-popup.component';
import { AddButtonComponent } from './components/add-button/add-button.component';
import { AddProjectTaskComponent } from './components/add-project-task/add-project-task.component';
import { AddRoleComponent } from './components/addrole/add-role.component';
import { BookModalComponent } from './components/book-modal/book-modal.component';
import { BriefingComponent } from './components/briefing/briefing.component';
import { CompanySwitcherComponent } from './components/company-switcher/company-switcher.component';
import { ConfirmPopupComponent } from './components/confirm-popup/confirm-popup.component';
import { DatepickerComponent } from './components/datepicker/datepicker.component';
import { DetailsHeaderComponent } from './components/details-header/details-header.component';
import { DropdownComponent } from './components/dropdown/dropdown.component';
import { UserDetailsFormComponent } from './components/edit-user-form/edit-user-form.component';
import { UserDetailsHeaderComponent } from './components/edit-user-header/edit-user-header.component';
import { FileUploadComponent } from './components/file-upload/file-upload.component';
import { HeaderComponent } from './components/header/header.component';
import { InputDropdownComponent } from './components/input-dropdown/input-dropdown.component';
import { LeftSidebarComponent } from './components/left-sidebar/left-sidebar.component';
import { LetterImageComponent } from './components/letter-image/letter-image.component';
import { LoaderComponent } from './components/loader/loader.component';
import { LocationDropdownComponent } from './components/location-dropdown/location-dropdown.component';
import { ModalActionsComponent } from './components/modal-actions/modal-actions.component';
import { ModalContentComponent } from './components/modal-content/modal-content.component';
import { ModalTitleComponent } from './components/modal-title/modal-title.component';
import { ModalWindowComponent } from './components/modal-window/modal-window.component';
import { ModalComponent } from './components/modal/modal.component';
import { NotesComponent } from './components/notes/notes.component';
import { PaginatorComponent } from './components/paginator/paginator.component';
import { PermissionsTableComponent } from './components/permissions-table/permissions-table.component';
import { ProjectsGroupedComponent } from './components/projects-grouped/projects-grouped.component';
import { RSConfirmPopupComponent } from './components/rs-confirm-popup/rs-confirm-popup.component';
import { ScheduleStatisticsComponent } from './components/schedule-statistics/schedule-statistics.component';
import { SearchFieldComponent } from './components/search-field/search-field.component';
import { SearchFilterComponent } from './components/search-filter/search-filter.component';
import { StatusFilterComponent } from './components/status-filter/status-filter.component';
import { SubheaderTabComponent } from './components/subheader-tab/subheader-tab.component';
import { SubheaderTabsComponent } from './components/subheader-tabs/subheader-tabs.component';
import { SubheaderComponent } from './components/subheader/subheader.component';
import { TagDropdownComponent } from './components/tag-dropdown/tag-dropdown.component';
import { TaskAndGroupsComponent } from './components/task-and-groups/task-and-groups.component';
import { TeamTaskTargetComponent } from './components/team-task-target/team-task-target.component';
import { TimeComponent } from './components/time/time.component';
import { UsersListComponent } from './components/users-list/users-list.component';
import { AutorunDirective } from './directives/autorun.directive';
import { CodeFlaskDirective } from './directives/code-flask/code-flask.directive';
import { CollapseDirective } from './directives/collapse.directive';
import { CurrencyDirective } from './directives/currency.directive';
import { DisableControlDirective } from './directives/disable-control.directive';
import { DisableInputDirective } from './directives/disable-input.directive';
import { DragDropDirective } from './directives/dragdrop.directive';
import { DropdownTemplateDirective } from './directives/dropdown-template/dropdown-template.directive';
import { EditableViewAdapterDirective } from './directives/editable-view-adapter.directive';
import { HoverPopoverDirective } from './directives/hover-popover.directive';
import { LoadingDirective } from './directives/loading.directive';
import { MapSearchDirective } from './directives/map-search/map-search.directive';
import { PopoverDirective } from './directives/popover/popover.directive';
import { ReactionDirective } from './directives/reaction.directive';
import { ScrollToTopDirective } from './directives/scroll-to-top/scroll-to-top.directive';
import { SignalsAutorunDirective } from './directives/signals-autorun.directive';
import { SimplebarDirective } from './directives/simplebar.directive';
import { ButtonSpinnerDirective } from './directives/spinner.directive';
import { TableHoverDirective } from './directives/table-hover.directive';
import { TextareaAutosizeDirective } from './directives/textarea-autosize.directive';
import { TimeMaskDirective } from './directives/time-mask.directive';
import { TippyUpdateDirective } from './directives/tippy-update.directive';
import { TippyVisibleDirective } from './directives/tippy-visible.directive';
import { TooltipDirective } from './directives/tooltip.directive';
import { TrackCaretPositionDirective } from './directives/track-caret-position';
import { AsDateControlPipe } from './pipes/as-date-control.pipe';
import { CompanyCurrencyPipe } from './pipes/company-currency.pipe';
import { CompanyNumberPipe } from './pipes/company-number.pipe';
import { DistanceFormatPipe } from './pipes/distance-format.pipe';
import { FileSizePipe } from './pipes/file-size.pipe';
import { FormatDatePipe } from './pipes/format-date.pipe';
import { FromCentsPipe } from './pipes/from-cents.pipe';
import { FromPercentsPipe } from './pipes/from-percents.pipe';
import { FullnamePipe } from './pipes/contact/fullname.pipe';
import { EmailPipe } from './pipes/contact/email.pipe';
import { PhonePipe } from './pipes/contact/phone.pipe';
import { IsLeftPipe } from './pipes/is-left.pipe';
import { IsLoadingPipe } from './pipes/is-loading.pipe';
import { IsNonePipe } from './pipes/is-none.pipe';
import { IsRightPipe } from './pipes/is-right.pipe';
import { IsSomePipe } from './pipes/is-some.pipe';
import { NotNullPipe } from './pipes/not-null.pipe';
import { ObjectValuesPipe } from './pipes/object-values.pipe';
import { TimePipe } from './pipes/time.pipe';
import { ToCentsPipe } from './pipes/to-cents.pipe';
import { ToDatePipe } from './pipes/to-date.pipe';
import { ToJSPipe } from './pipes/to-js.pipe';
import { ToPercentsPipe } from './pipes/to-percents.pipe';
import { ToPipe } from './pipes/to.pipe';
import { UnwrapFormControlPipe } from './pipes/unwrap-form-control.pipe';
import { UploadsPipe } from './pipes/uploads/uploads.pipe';
import { ZonedDateToUTCPipe } from './pipes/zoned-date-to-utc.pipe';
import { SummaryComponent } from './components/teamcost/summary/summary.component';
import { TransportComponent } from './components/transport/transport.component';
import { ArrayToList } from '@macs-frontend/web-macs/shared/pipes/array-to-list.pipe';
import { TableFilterDateComponent } from '@macs-frontend/features/shared/components/table-filter-date/table-filter-date.component';
import { TableFilterTextComponent } from '@macs-frontend/features/shared/components/table-filter-text/table-filter-text.component';
import { TableFilterDropdownComponent } from '@macs-frontend/features/shared/components/table-filter-dropdown/table-filter-dropdown.component';
import { TimetrackingCalendarComponent } from '@macs-frontend/features/shared/components/calendar-view/calendar.component';
import { TimetrackingCalendarActionsComponent } from '@macs-frontend/features/shared/components/calendar-view/calendar-actions/calendar-actions.component';
import { CalendarModule } from 'angular-calendar';
import { TableSorterComponent } from '@macs-frontend/features/shared/components/table-sorter/table-sorter.component';
import { AssignmentsMenuItemComponent } from './components/assignments-menu-item/assignments-menu-item.component';
import { AssignmentConfirmDialogComponent } from './components/assignment-confirm-dialog/assignment-confirm-dialog.component';
import { DimonaStatusDotComponent } from '@macs-frontend/features/shared/components/dimona-status-dot/dimona-status-dot.component';
import { DragScrollDirective } from '@macs-frontend/features/shared/directives/drag-scroll.directive';
import { PreventOverflowOnHoverDirective } from '@macs-frontend/features/shared/directives/prevent-overflow-on-hover.directive';
import { NotificationsMenuItemComponent } from '@macs-frontend/features/shared/components/notifications-menu-item/notifications-menu-item.component';
import { WrapLoaderComponent } from '@macs-frontend/features/shared/components/wrap-loader/wrap-loader.component';
import { FormErrorsComponent } from '@macs-frontend/features/shared/components/form-errors/form-errors.component';
import { ThreeDotsMenuComponent } from '@macs-frontend/features/shared/components/three-dots-menu/three-dots-menu.component';
import { TabsMenuComponent } from './components/tabs-menu/tabs-menu.component';
import { TabsBgComponent } from './components/tabs-bg/tabs-bg.component';
import { TabsBgItemComponent } from './components/tabs-bg/tabs-bg-item.component';

const MODULES = [
  UIModule,
  RouterModule,
  NgrxFormsModule,
  AutoSizeInputModule,
  MatDatepickerModule,
  InfiniteScrollModule,
  IMaskModule,
  MatDialogModule,
  UIKitModule,
  NgxSliderModule,
  GoogleMapsModule,
  FormsModule,
  CommonModule,
  MatButtonModule,
  MatTooltipModule,
  MobxAngularModule,
  NgxTippyModule,
  ContenteditableValueAccessorModule,
  CalendarModule,
  NgxMaskDirective,
  NgxMaskPipe,
  OverlayModule,
];

const DECLARATIONS = [
  LoadingDirective,
  AutorunDirective,
  SignalsAutorunDirective,
  ReactionDirective,
  LeftSidebarComponent,
  HeaderComponent,
  SubheaderComponent,
  SubheaderTabsComponent,
  SubheaderTabComponent,
  DropdownComponent,
  StatusFilterComponent,
  PaginatorComponent,
  TableHoverDirective,
  TrackCaretPositionDirective,
  TooltipDirective,
  AddRoleComponent,
  UsersListComponent,
  TagDropdownComponent,
  UserDetailsHeaderComponent,
  UserDetailsFormComponent,
  InputDropdownComponent,
  LetterImageComponent,
  ProjectsGroupedComponent,
  IsLoadingPipe,
  PermissionsTableComponent,
  SimplebarDirective,
  CollapseDirective,
  TextareaAutosizeDirective,
  DisableInputDirective,
  DisableControlDirective,
  EditableViewAdapterDirective,
  PopoverDirective,
  HoverPopoverDirective,
  DropdownTemplateDirective,
  MapSearchDirective,
  CodeFlaskDirective,
  AddButtonComponent,
  DistanceFormatPipe,
  FromCentsPipe,
  CompanyNumberPipe,
  ToCentsPipe,
  ToPipe,
  ToJSPipe,
  NotNullPipe,
  IsSomePipe,
  IsNonePipe,
  IsLeftPipe,
  IsRightPipe,
  ToDatePipe,
  TippyUpdateDirective,
  UnwrapFormControlPipe,
  AsDateControlPipe,
  FormatDatePipe,
  ZonedDateToUTCPipe,
  ToPercentsPipe,
  ActionTeamNamePipe,
  ProvinceLabelPipe,
  ActionConfirmationStatusPipe,
  FromPercentsPipe,
  ObjectValuesPipe,
  DatepickerComponent,
  SearchFieldComponent,
  SearchFilterComponent,
  CurrencyDirective,
  CompanyCurrencyPipe,
  UploadsPipe,
  ConfirmPopupComponent,
  ActionsPopupComponent,
  FileSizePipe,
  TeamTaskTargetComponent,
  TaskAndGroupsComponent,
  AddProjectTaskComponent,
  ModalWindowComponent,
  LoaderComponent,
  OutsideClickDirective,
  DragDropDirective,
  ScrollToTopDirective,
  FilterDropdownComponent,
  FilterBarComponent,
  CalculateAgePipe,
  TitleCasePipe,
  SnakeCaseToDashCase,
  CompanySwitcherComponent,
  FullnamePipe,
  EmailPipe,
  PhonePipe,
  FromNowPipe,
  FileUploadComponent,
  LocationDropdownComponent,
  ScheduleTimelineComponent,
  ScheduleTimelineGraphComponent,
  TeamCostComponent,
  TaskComponent,
  ServiceComponent,
  SummaryComponent,
  ScheduleStatisticsComponent,
  BookModalComponent,
  EnumValuesToArrayPipe,
  SecondsToHoursPipe,
  EnumValuesToArrayPipe,
  ButtonSpinnerDirective,
  BriefingComponent,
  DetailsHeaderComponent,
  TimeComponent,
  TippyVisibleDirective,
  TimeMaskDirective,
  ModalComponent,
  ModalTitleComponent,
  ModalContentComponent,
  ModalActionsComponent,
  TableComponent,
  TableHeaderComponent,
  RSConfirmPopupComponent,
  AttachedComponent,
  NumberInputDirective,
  TimePipe,
  TagsComponent,
  NotesComponent,
  HumanizeTextCodePipe,
  RangeInputDirective,
  FormErrorDirective,
  ModalRightComponent,
  ActionsMenuComponent,
  SaveButtonComponent,
  ExactSyncSpinnerComponent,
  InvoiceItemQuantityPipe,
  ProjectEstimatedAbsoluteMarginPipe,
  ToStringPipe,
  PromptPopupComponent,
  ActivityLogComponent,
  SpoStatusTooltipComponent,
  TransportComponent,
  DropdownUserOptionComponent,
  DropdownUserSelectedComponent,
  ContactKindBadgeComponent,
  ArrayToList,
  TableFilterDateComponent,
  TableFilterTextComponent,
  TableFilterDropdownComponent,
  TimetrackingCalendarComponent,
  TimetrackingCalendarActionsComponent,
  TableSorterComponent,
  AssignmentsMenuItemComponent,
  NotificationsMenuItemComponent,
  AssignmentConfirmDialogComponent,
  DimonaStatusDotComponent,
  DragScrollDirective,
  PreventOverflowOnHoverDirective,
  WrapLoaderComponent,
  FormErrorsComponent,
  TabsMenuComponent,
  TabsBgComponent,
  TabsBgItemComponent,
  ThreeDotsMenuComponent,
];

@NgModule({
  declarations: [...DECLARATIONS],
  imports: [...MODULES],
  exports: [...MODULES, ...DECLARATIONS],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [...provideNgxMask()],
})
export class SharedModule {}
